<template>
  <v-row class="customer-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0">
      <div class="new-white-box-overview-main nav">
        <div class="col-md-12 pt-0 px-0">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="text@5"
          >
          </v-skeleton-loader>

          <table v-else class="width-100">
            <template>
              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Status
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.status">
                    <v-chip
                      small
                      :color="`${statusColor(lead.status)} white--text`"
                      label
                      class="mt-2"
                      style="padding: 10px"
                    >
                      <span class="font-size-16 font-weight-700">{{
                        getFormattedText(lead.status)
                      }}</span>
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">No Status </em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Company Name
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.company_name">{{
                    lead.company_name
                  }}</template>
                  <template v-else>
                    <em class="text-muted">No company name</em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Lead Date
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.lead_date">{{
                    formatDate(lead.lead_date)
                  }}</template>
                  <template v-else>
                    <em class="text-muted">No Lead Date </em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Assign To
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template
                    v-if="lead.assigned_user && lead.assigned_user.display_name"
                    >{{ lead.assigned_user.display_name }}</template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Opportunity
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.opportunity">
                    <v-chip
                      small
                      color="chip-custom-blue"
                      outlined
                      label
                      style="padding: 10px"
                    >
                      <span
                        class="font-size-16 font-weight-500 text-capitalize"
                      >
                        {{ lead.opportunity }}
                      </span>
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">No Opportunity</em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Product Type
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.product_type">
                    <v-chip
                      small
                      color="chip-custom-blue"
                      outlined
                      label
                      style="padding: 10px"
                    >
                      <span
                        class="font-size-16 font-weight-500 text-capitalize"
                      >
                        {{ lead.product_type }}
                      </span>
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">No Product Type </em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Source
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.source">
                    <v-chip
                      small
                      color="chip-custom-blue"
                      outlined
                      label
                      style="padding: 10px"
                    >
                      <span
                        class="font-size-16 font-weight-500 text-capitalize"
                      >
                        {{ lead.source }}
                      </span>
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">No Source</em></template
                  >
                </td>
              </tr>

              <!--   <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Amount
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                   <template v-if="lead.amount && lead.amount > 0">
                        <v-chip
                            small
                            class="py-0"
                            color="green"
                            label
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;"
                          >
                          <span class="text-white">
                            <b>${{ ' ' + lead.amount }}</b>
                            </span>
                          </v-chip>
                      </template>
                  <template v-else>
                    <em class="text-muted">No Amount</em></template
                  >
                </td>
              </tr> -->

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Position
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.position">{{ lead.position }}</template>
                  <template v-else>
                    <em class="text-muted">No Position</em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Entity
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.entity">{{ lead.entity }}</template>
                  <template v-else>
                    <em class="text-muted">No Entity</em></template
                  >
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Expected Close Date
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.expected_close_date">
                    {{ formatDate(lead.expected_close_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted">No Expected Close Date</em>
                  </template>
                  <v-menu
                    v-if="getPermission('lead:update')"
                    v-model="expectedCloseDatePicker"
                    :close-on-content-click="false"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        color="cyan"
                        class="ml-2"
                        :loading="closeDateSaving"
                        :disabled="closeDateSaving"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon left small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <v-date-picker
                      color="cyan"
                      :value="lead.expected_close_date"
                      @input="updateCloseDate('expected_close_date', $event)"
                    ></v-date-picker>
                  </v-menu>
                </td>
              </tr>

              <tr>
                <td
                  class="py-1 font-size-18 font-weight-500 text-capitalize"
                  width="200"
                >
                  Actual Closed Date
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.actual_closed_date">
                    {{ formatDate(lead.actual_closed_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted">No Actual Closed Date</em>
                  </template>
                  <v-menu
                    v-if="getPermission('lead:update')"
                    v-model="actualClosedDatePicker"
                    :close-on-content-click="false"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        small
                        color="cyan"
                        class="ml-2"
                        :loading="closeDateSaving"
                        :disabled="closeDateSaving"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon left small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <v-date-picker
                      color="cyan"
                      :value="lead.actual_closed_date"
                      @input="updateCloseDate('actual_closed_date', $event)"
                    ></v-date-picker>
                  </v-menu>
                </td>
              </tr>

              <!--

               <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Address Line 1
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.address_line_1">{{
                    lead.address_line_1
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no address line 1</em></template
                  >
                </td> 
              </tr>

                <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Address Line 2
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.address_line_2">{{
                    lead.address_line_2
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no address line 2</em></template
                  >
                </td> 
              </tr>

              <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Postal Code
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.postal_code">{{
                    lead.postal_code
                  }}</template>
                  <template v-else>
                    <em class="text-muted">no postal code</em></template
                  >
                </td> 
              </tr>

               <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Unit No.
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.unit_no">{{
                    lead.unit_no
                  }}</template>
                  <template v-else>
                    <em class="text-muted">No Unit No.</em></template
                  >
                </td>
              </tr>

               <tr>
                <td class="py-1 font-size-18 font-weight-500 text-capitalize" width="200">
                  Country
                </td>
                <td class="py-1 font-size-18 text-capitalize">
                  <template v-if="lead.country">{{
                    lead.country
                  }}</template>
                  <template v-else>
                    <em class="text-muted">No Country</em></template
                  >
                </td>
              </tr> -->
            </template>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import { PATCH } from "@/core/services/store/request.module";

export default {
  name: "contact-details",
  title: "Lead",
  mixins: [CommonMixin, FileManagerMixin],
  data() {
    return {
      imageLoading: false,
      expectedCloseDatePicker: false,
      actualClosedDatePicker: false,
      closeDateSaving: false,
    };
  },
  props: {
    lead: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateCloseDate(field, date) {
      if (!date || !this.lead.id) {
        return;
      }

      this.closeDateSaving = true;
      this.$store
        .dispatch(PATCH, {
          url: `leads/${this.lead.id}/close-dates`,
          data: { [field]: date },
        })
        .then(() => {
          this.expectedCloseDatePicker = false;
          this.actualClosedDatePicker = false;
          this.$emit("updated");
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.closeDateSaving = false;
        });
    },

    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },

    statusColor(status) {
      const statusMapping = {
        "Not Contacted": "grey",
        "Follow Up": "yellow",
        Meeting: "blue",
        "Converted to Customer": "orange",
        Accepted: "green",
        Rejected: "red",
      };

      return statusMapping[status] || "grey";
    },

    getFormattedText(status) {
      if (!status) return "";
      return status
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  components: {},
  computed: {
    leadActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.lead) === false) {
        return _this.lead.activated;
      }
      return false;
    },

    getProfileImage() {
      if (!this.lead.profile_logo) {
        return null;
      }
      return this.lead.profile_logo.file.url;
    },
    getBarcode() {
      if (!this.lead.barcode) {
        return "";
      }
      return this.lead.barcode;
    },
  },
};
</script>
